$(document).ready(function(){ 

setTimeout(function(){
  $('smart-stories').css({"opacity":'1'})
}, 1000)
   
     
}); 


//collection-{{ section.id }}
  //$('.new-collection-1, .new-collection-2').slick({
 

 


 

$(document).ready(function(){
 
  $('.video-mp4-wrapper-open-poup').on('click', function(e){
    e.preventDefault();
    var data_id = $(this).attr('data-id');
    //$('#'+data_id).addClass('active');
    var data_video = $(this).attr('data-video');
    $('.video-mp4-wrapper-popup-section').addClass('active');
    console.log('data_video',data_video)
    $('.video-mp4-wrapper-popup-section .video_div').html('<video autoplay="" loop="" muted="" playsinline="" preload="auto"><source type="video/mp4" src="'+data_video+'"></video>');

    setTimeout(function(){
    $(".video-mp4-wrapper-popup-section.active video").prop('muted', false);
      }, 100)
    $('.video-mp4-wrapper-popup-mute-unmute').removeClass('active');
    $('.video-mp4-wrapper-popup-play-pause').removeClass('active');
    
  })
  $('.video-mp4-wrapper-popup-close').on('click', function(e){
    e.preventDefault();
    var data_id = $(this).attr('data-id');
    //$('#'+data_id).removeClass('active');
   // $('.video-mp4-wrapper-popup-section video source').attr('src','');
    $('.video-mp4-wrapper-popup-section').removeClass('active');
    $(".video-mp4-wrapper-popup-section video").prop('muted', true);
    $('.video-mp4-wrapper-popup-mute-unmute').removeClass('active');
    $('.video-mp4-wrapper-popup-play-pause').removeClass('active');
  })

  $('.video-mp4-wrapper-popup-mute-unmute').on('click', function(e){
    e.preventDefault();
    console.log('testt');
    $(this).toggleClass('active');
    setTimeout(function(){
  if( $(".video-mp4-wrapper-popup-mute-unmute").hasClass('active'))
  {
  $(".video-mp4-wrapper-popup-section.active video").prop('muted', true);
    console.log('iff')
  }

  else {
    console.log('elsee')
     $(".video-mp4-wrapper-popup-section.active video").prop('muted', false);
  }
      }, 100)
})


$('.video-mp4-wrapper-popup-play-pause').on('click', function(e){
    e.preventDefault();
    console.log('testt');
    $(this).toggleClass('active');
    setTimeout(function(){
  if( $(".video-mp4-wrapper-popup-play-pause").hasClass('active'))
  {
  $(".video-mp4-wrapper-popup-section.active video").trigger('pause');
    console.log('iff')
  }

  else {
    console.log('elsee')
     $(".video-mp4-wrapper-popup-section.active video").trigger('play');
  }
      }, 100)
})

  
  
}) 

 
$( document ).ready(function() {
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

    
  $('.tab-slide').slick({
  dots: false,
  infinite: false,
  speed: 300,
autoplay:false,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
  $('.professer-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
autoplay:true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
  $('#tabs-nav li').on('click', function(){
              $('.tab-slide').slick('unslick');
    $('.professer-slider').slick('unslick');
    $('.tab-slide').slick({
  dots: false,
  infinite: false,
  speed: 300,
autoplay:false,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
  $('.professer-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
autoplay:true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
  });

  


createSlick();
}); 

 var maxwidth = 1024;
  function createSlick(){
$(".user-grid-slider").not('.slick-initialized').slick({
  autoplay: false,
  dots: false,
  infinite: false,
  slidesToShow: 6,
  prevArrow: '<button class="slide-arrow prev-arrow user-slide-arrow-left"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0565/0527/0341/files/down-arrow.png?v=1699359214"></button>',
    nextArrow: '<button class="slide-arrow next-arrow user-slide-arrow-right"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0565/0527/0341/files/down-arrow.png?v=1699359214"></button>',
  slidesToScroll: 1,
  responsive: [{
      breakpoint: maxwidth,
      settings: 'unslick'
  }]
});

}

//Now it will not throw error, even if called multiple times.
$(window).on( 'resize', createSlick );

 
 if ($('.testimonial-slide').length) {
   $('.testimonial-slide').slick({
  dots: true,
  infinite: false,
  speed: 300,
autoplay:false,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1
      }
    }
  ]
}); 
 }

